"use client";

import { TContentCard } from "@shared/types";
import Image from "next/image";

export function ProductBenefitCards({ items }: { items: TContentCard[] }) {
  return (
    <div className="space-y-4">
      {items.map((item: TContentCard) => (
        <div key={`benefit-value-${item.id}`}>
          <div className="inline-flex gap-2 sm:gap-3 bg-white px-3 py-2 sm:px-4 sm:py-3 rounded-xl text-base sm:text-xl">
            {item?.icon?.data?.attributes?.url && (
              <Image
                src={item?.icon?.data?.attributes?.url}
                height={item?.icon?.data?.attributes?.height}
                width={item?.icon?.data?.attributes?.width}
                alt={item?.icon?.data?.attributes?.alternativeText || item?.icon?.data?.attributes?.name || "Benefit Item Icon"}
                className="mt-0.5 sm:mt-1 size-5 min-w-5 sm:size-6 sm:min-w-6 flex-shrink-0"
              />
            )}

            <span className="font-medium flex-1 whitespace-normal">{item.title}</span>
          </div>
        </div>
      ))}
    </div>
  );
}
